module.exports = __webpack_public_path__ + "img/Weapon_84.c351233a.png";